import { c as _c } from "react/compiler-runtime";
import type { Money } from '@newfront-insurance/core-money';
import { toMoney, toNumberFromMoney } from '@newfront-insurance/core-money';
import { CheckboxRow, CurrencyInput, Flexbox, Text } from '@newfront-insurance/core-ui';
import type { CurrencyOrCheckboxInputMetadata } from '@newfront-insurance/coverage-api';
import { getStringifiedFieldValue } from '@newfront-insurance/dsl-schema-ui';
import type { SchemaInputControlCustomInputProps, CustomValue } from '@newfront-insurance/dsl-schema-ui';
import type { JSX } from 'react';
export type CurrencyOrCheckboxInputValue = Record<string, Money | boolean | undefined> | undefined;
export function CurrencyOrCheckboxDslInput(t0) {
  const $ = _c(22);
  const {
    onChange,
    value,
    metadata
  } = t0;
  if (!metadata) {
    return null;
  }
  const checkboxValue = value?.[metadata.checkboxFieldName] || false;
  const moneyValue = value?.[metadata.currencyFieldName] as Money | undefined;
  let t1;
  if ($[0] !== checkboxValue || $[1] !== metadata || $[2] !== onChange || $[3] !== value) {
    t1 = function handleCurrencyChange(currencyValue) {
      if (!metadata) {
        return;
      }
      if (checkboxValue) {
        return;
      }
      if (!currencyValue && !checkboxValue) {
        onChange(undefined);
        return;
      }
      onChange({
        ...value,
        [metadata.currencyFieldName]: currencyValue ? toMoney(currencyValue) : undefined,
        [metadata.checkboxFieldName]: checkboxValue || false
      });
    };
    $[0] = checkboxValue;
    $[1] = metadata;
    $[2] = onChange;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleCurrencyChange = t1;
  let t2;
  if ($[5] !== metadata || $[6] !== onChange) {
    t2 = function handleCheckboxChange(isActive) {
      if (!metadata) {
        return;
      }
      if (!isActive) {
        onChange(undefined);
        return;
      }
      onChange({
        [metadata.checkboxFieldName]: true
      });
    };
    $[5] = metadata;
    $[6] = onChange;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleCheckboxChange = t2;
  let t3;
  if ($[8] !== moneyValue) {
    t3 = moneyValue ? toNumberFromMoney(moneyValue) : "";
    $[8] = moneyValue;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = !!checkboxValue;
  let t5;
  if ($[10] !== handleCurrencyChange || $[11] !== metadata.currencyFieldName || $[12] !== t3 || $[13] !== t4) {
    t5 = <CurrencyInput onChange={handleCurrencyChange} value={t3} disabled={t4} name={metadata.currencyFieldName} />;
    $[10] = handleCurrencyChange;
    $[11] = metadata.currencyFieldName;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = metadata?.checkboxFieldLabel ?? "";
  const t7 = !!checkboxValue;
  let t8;
  if ($[15] !== handleCheckboxChange || $[16] !== t6 || $[17] !== t7) {
    t8 = <CheckboxRow label={t6} isActive={t7} onClick={handleCheckboxChange} />;
    $[15] = handleCheckboxChange;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t8) {
    t9 = <Flexbox flexDirection="column" gap={8} marginTop="auto">{t5}{t8}</Flexbox>;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}

// eslint-disable-next-line react/function-component-definition
export const CurrencyOrCheckboxDisplay: CustomValue<CurrencyOrCheckboxInputValue, CurrencyOrCheckboxInputMetadata> = t0 => {
  const $ = _c(5);
  const {
    field,
    value
  } = t0;
  let t1;
  if ($[0] !== field || $[1] !== value) {
    t1 = getStringifiedFieldValue(value, field);
    $[0] = field;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Text>{t1}</Text>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};